import React from "react";
import { Capabilities, PermissionName } from "../../clients/graphqlTypes.js";
import { Restricted } from "./Restricted.js";
import { RestrictedByCapabilityWithDebug } from "./RestrictedByCapability.js";
import {
  type Document,
  RestrictedByDocumentPermissionWithDebug,
} from "./RestrictedByDocumentPermission.js";

interface Props extends Omit<
  React.ComponentProps<typeof Restricted>,
  "isRestricted"
> {
  capability: Capabilities | Capabilities[];
  permission: PermissionName;
  document: Document;
}

export const RestrictedByCapabilityAndDocumentPermissionWithDebug = ({
  capability,
  document,
  permission,
  children,
  otherwise,
  ...props
}: Props) => {
  const capabilities = Array.isArray(capability) ? capability : [capability];
  return capabilities.reduceRight(
    (content, capability) => (
      <RestrictedByCapabilityWithDebug
        capability={capability}
        otherwise={otherwise}
      >
        {content}
      </RestrictedByCapabilityWithDebug>
    ),
    <RestrictedByDocumentPermissionWithDebug
      permission={permission}
      document={document}
      otherwise={otherwise}
      {...props}
    >
      {children}
    </RestrictedByDocumentPermissionWithDebug>
  );
};
